import { createApi } from '@/api'
export default {
  produceTypeList: config => createApi(`/produceType/getList`, 'get', config), // 农产品类型列表
  addProduceType: config => createApi(`/produceType/add`, 'post', config), // 农产品类型添加
  deleteProduceType: config => createApi(`/produceType/delete`, 'delete', config), // 农产品类型删除
  updateProduceType: config => createApi(`/produceType/update`, 'post', config), // 农产品类型修改
  produceTypeDetail: config => createApi(`/produceType/get`, 'get', config) // 农产品类型详情
}



// WEBPACK FOOTER //
// ./src/views/produceTypeManage/api/index.js